import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detect',
  templateUrl: './detect.component.html',
  styleUrls: ['./detect.component.css'],
})
export class DetectComponent {
  // constructor() {}
  // ngOnInit(): void {}
}
